/**
 * Display helpers for backend enum values. The stored values ('inquilino',
 * 'propietario', 'Cliente', 'Inmobiliaria') are part of the API contract and
 * must never change; only their on-screen labels go through the terminology
 * layer. Unknown values pass through untouched.
 */

const PARTY_TYPE_KEYS = {
	'inquilino': 'enum.partyType.inquilino',
	'propietario': 'enum.partyType.propietario',
};

const PAYMENT_TO_KEYS = {
	'Cliente': 'enum.paymentTo.cliente',
	'Inmobiliaria': 'enum.paymentTo.inmobiliaria',
};

export const partyTypeLabel = (t, value) => {
	const key = PARTY_TYPE_KEYS[value];
	return key ? t(key) : value;
};

export const paymentToLabel = (t, value) => {
	const key = PAYMENT_TO_KEYS[value];
	return key ? t(key) : value;
};
